import React from 'react'
import { useAuth } from '@hooks/useAuth'
import { defaultLoginValue } from '@store/loginUser'
import { api } from '@api/index'
import { Link } from 'react-router-dom'
import { FieldValues, useForm } from 'react-hook-form'
import { Message } from '@utils/message'

interface Form {
  id: string
  password: string
}

const LandingPage = () => {
  const { login } = useAuth()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Form>({ mode: 'onChange' })

  const authorization = async (id: string, password: string) => {
    try {
      const tokenInfo = await api.userService.login(id, password)
      const userInfo = await api.userService.tokenToUser(tokenInfo.token)
      login({
        ...userInfo,
        token: {
          accessToken: tokenInfo.token,
          accessTokenExpiration: tokenInfo.expiration,
        },
      })
    } catch {}
  }

  const handleLoginClick = ({ id, password }: Form) => {
    authorization(id, password)
  }

  return (
    <>
      <section className="w-300">
        <form onSubmit={handleSubmit(handleLoginClick)}>
          <div className="mb-12 text-2xl font-bold flex-center ">로그인</div>
          <div className="flex flex-col w-full gap-12 mb-12">
            <label>아이디</label>
            <input
              {...register('id', { required: Message.valid.REQUIRE_ID })}
              type="text"
              className="input"
            />
            <div className="flex items-center h-5 py-2 text-base text-red-500">
              {errors?.id?.message}
            </div>
            <label>비밀번호</label>
            <input
              {...register('password', {
                required: Message.valid.REQUIRE_PASSWORD,
              })}
              type="password"
              className="input"
            />
            <div className="flex items-center h-5 py-2 text-base text-red-500 ">
              {errors?.password?.message}
            </div>
          </div>
          <button type="submit" className="w-full py-5 mt-4 font-bold button">
            로그인
          </button>
        </form>
        <ul className="flex items-center justify-between gap-8 mt-20 under:text-base">
          <li>
            <Link to="/tos">회원가입</Link>
          </li>
          <li>
            <Link to="/find-id">아이디찾기</Link>
          </li>
          <li>
            <Link to="/find-password">비밀번호찾기</Link>
          </li>
        </ul>
      </section>
    </>
  )
}

export default LandingPage
